// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1 tid="bankTokenErrorHeader">Payment Not Processed</h1>
        </div>
        <div class="hoa-dialog__main">
            <div tid="bankTokenErrorBody"><span>{{data.errorMessage}}</span></div>
        </div>
        <div class="hoa-dialog__footer" [ifOverFlowXClass]="'hoa-dialog__footer--overflowX'">
            <button class="Button Button--blue Button--minWidth130" tid="bankTokenErrorClose" (click)="closeThisDialog()">
                Close
            </button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;